import { supabase } from '@loop3/supabase-client'
import {
  lastKbSync,
  listSolutions as listKbSolutions,
  searchSolutions as searchKbSolutions,
  solutionIdsForPerson,
  solutionById,
  type SolutionDetail,
  type SolutionListItem,
} from '@loop3/universe'
import type { Entity } from '@/lib/types/universe'

// Small corpus, ranked client-side: a low cap would cut the best matches before ranking.
const SEARCH_LIMIT = 50

/** Live kb solutions matching the query by full text or name; [] when nothing searchable is left. */
export function searchSolutions(q: string): Promise<Entity[]> {
  return searchKbSolutions(supabase, q, SEARCH_LIMIT)
}

/** One solution by kb uuid or Notion page id, archived included; null when unknown, malformed or hidden by RLS. */
export function getSolution(id: string): Promise<SolutionDetail | null> {
  return solutionById(supabase, id)
}

/** Every live kb solution and feature with its facets. */
export function listSolutions(): Promise<SolutionListItem[]> {
  return listKbSolutions(supabase)
}

/** When the newest kb sync finished, or null before the first run. */
export function getLastKbSync(): Promise<string | null> {
  return lastKbSync(supabase)
}

/** Ids of kb solutions a person (persons.id) worked on as a teammate. */
export function getPersonSolutionIds(personsId: string): Promise<string[]> {
  return solutionIdsForPerson(supabase, personsId)
}
